import React from 'react';
import { FormShowTemplate } from 'framework/form';
import AcceptancePoliciesList from './AcceptancePoliciesList';
import { EditableListFormShowTemplate } from 'framework/list';

const getDataFunc = async () => ({
  policyLinksData: [{ index: 1, name: 'Acceptance policy' }],
});

const AcceptancePoliciesContext = () => (
  <FormShowTemplate getDataFunc={getDataFunc} submitFormFunc={() => Promise.resolve()} afterSubmit={{}}>
    <EditableListFormShowTemplate listSource="policyLinksData">
      <AcceptancePoliciesList />
    </EditableListFormShowTemplate>
  </FormShowTemplate>
);

export default AcceptancePoliciesContext;
